import { render } from "./EMRNotSend.vue?vue&type=template&id=368328d7"
import script from "./EMRNotSend.vue?vue&type=script&lang=js"
export * from "./EMRNotSend.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/EMRNotSend.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "368328d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('368328d7', __exports__)) {
    console.log('reload')
    api.reload('368328d7', __exports__)
  }
  
  module.hot.accept("./EMRNotSend.vue?vue&type=template&id=368328d7", () => {
    console.log('re-render')
    api.rerender('368328d7', render)
  })

}


export default __exports__